import { useState } from 'react';

const zzzfunFaqs = [
  {
    q: 'ZzzFun是什么？',
    a: 'ZzzFun是一款以兴趣为核心的番剧播放工具，提供排行榜、新番时间表、分区发现、高清播放与多端同步等功能。',
  },
  {
    q: 'ZzzFun支持哪些平台下载？',
    a: 'ZzzFun官方客户端覆盖 Android、iOS、HarmonyOS 与 Windows，点击页面上的下载按钮即可选择对应系统进行下载。',
  },
  {
    q: '下载和观看需要付费吗？',
    a: 'ZzzFun客户端可免费下载安装，基础观看功能无需付费，安装包安全无捆绑，请通过官方渠道获取。',
  },
  {
    q: '换设备后追番进度会丢失吗？',
    a: '不会。登录同一账号后，收藏列表与观看进度会通过云端同步，在任意设备上都能接着上次的位置继续观看。',
  },
  {
    q: '在哪里可以找到ZzzFun动漫官网下载？',
    a: '直接访问ZzzFun.net即可进入官方下载页面，或通过本站ZzzFun官方APP免费下载入口获取最新版本客户端。',
  },
];

export default function ZzzfunFaq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="zzzfun-faq" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-accent-600">FAQ</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于ZzzFun下载与使用，你可能想了解这些。
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-3xl">
          {zzzfunFaqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={faq.q}
                className="mb-3 overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">{faq.q}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-700">
                    <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'} />
                  </span>
                </button>
                {open ? (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}